
import { useEffect } from 'react';
import { eventService } from '@/services/eventService';
import { Event } from '@/types/event';

interface EventSubscriptionProps {
  eventId: string;
  onEventUpdate: (event: Event) => void;
}

export const EventSubscription: React.FC<EventSubscriptionProps> = ({ 
  eventId, 
  onEventUpdate 
}) => {
  useEffect(() => {
    console.log('Setting up real-time subscription for event:', eventId);
    
    const unsubscribe = eventService.subscribeToEvent(eventId, (updatedEvent) => {
      console.log('Received real-time event update:', updatedEvent);
      onEventUpdate(updatedEvent);
    });

    return () => {
      console.log('Cleaning up event subscription');
      unsubscribe();
    };
  }, [eventId, onEventUpdate]);

  return null; // This component doesn't render anything
};
